<template>
  <section class="home-bottom-section">
    <div class="container">
      <div class="content-wrapper">
        <!-- Left Vertical Tabs -->
        <div class="tabs-container">
          <button
            class="tab-btn"
            :class="{ active: activeTab === 'success' }"
            @click="activeTab = 'success'"
          >
            中标/成交公告
          </button>
          <button
            class="tab-btn"
            :class="{ active: activeTab === 'fail' }"
            @click="activeTab = 'fail'"
          >
            废标/终止公告
          </button>
        </div>

        <!-- Right List Content -->
        <div class="list-container">
          <div class="list-content">
            <div
              v-for="item in currentList"
              :key="item.id"
              class="list-item"
              @click="handleItemClick(item)"
            >
              <div class="item-left">
                <span class="dot"></span>
                <p class="item-title">{{ item.title }}</p>
              </div>
              <span class="item-date">{{ item.date }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getNoticeList } from '@/api/common';

export default {
  name: "HomeBottomSection",
  data() {
    return {
      activeTab: "success",
      successList: [],
      failList: [],
      loading: false
    };
  },
  computed: {
    currentList() {
      return this.activeTab === "success" ? this.successList : this.failList;
    },
  },
  watch: {
    activeTab: {
      handler(val) {
        this.fetchData(val);
      },
      immediate: true
    }
  },
  methods: {
    fetchData(tab) {
      const type = tab === 'fail' ? 4 : 3;
      const params = {
        Key: '',
        type: type,
        CurrentPage: 1,
        ItemsPerPage: 8
      };
      
      this.loading = true;
      getNoticeList(params).then(res => {
        if (res && res.items) {
          const list = res.items.map(item => ({
            id: item.id,
            title: item.title,
            date: item.createdDate ? item.createdDate.split('T')[0] : ''
          }));
          
          if (tab === 'success') {
            this.successList = list;
          } else {
            this.failList = list;
          }
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    handleItemClick(item) {
      this.$router.push({ path: "procurement-detail", query: { id: item.id } });
    },
  },
};
</script>

<style lang="less" scoped>
.home-bottom-section {
  width: 100%;
  height: 604px;
  padding-top: 64px;
  background: url("@/assets/homeImages/home-bg02.png") no-repeat;
  background-size: 100% 100%;
  margin-bottom: 90px;
  z-index: 1;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 16px;
    position: relative;

    .content-wrapper {
      display: flex;
    }
  }

  .tabs-container {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 8px; // space-y-2
    background: url("@/assets/homeImages/home-left-bg.png") no-repeat;
    background-size: 100% 100%;
    backdrop-filter: blur(4px);
    padding-top: 80px;
    width: 200px;
    height: 540px;

    .tab-btn {
      text-align: left;
      padding: 16px 24px; // px-6 py-4
      font-weight: 600;
      font-size: 18px; // text-lg
      transition: all 0.3s;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
      border-left: 4px solid transparent;
      background: none;
      border-top: none;
      border-right: none;
      border-bottom: none;
      cursor: pointer;
      color: #2a375e; // text-gray-500

      &:hover {
        color: #5772c3; // text-blue-500
      }

      &.active {
        background: linear-gradient(
          270deg,
          rgba(87, 114, 195, 0) 0%,
          rgba(87, 114, 195, 0.16) 100%
        );
        // background-color: white;
        color: #5772c3; // text-blue-600
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        position: relative;

        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 4px;
          height: 56px;
          background-color: #5772c3;
        }
      }
    }
  }

  .list-container {
    flex: 1;
    background-color: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(12px);
    padding: 32px 32px 20px 24px; // p-8
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    margin-top: 80px;

    .list-content {
      display: flex;
      flex-direction: column;
      gap: 16px; // space-y-4

      .list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        border-bottom: 1px solid #f3f4f6;
        padding-bottom: 12px;

        &:last-child {
          border-bottom: none;
        }

        &:hover {
          .item-left {
            .dot {
              background-color: #5772c3;
            }

            .item-title {
              color: #5772c3;
            }
          }
        }

        .item-left {
          display: flex;
          align-items: center;
          flex: 1;
          min-width: 0;

          .dot {
            width: 6px;
            height: 6px;
            background-color: #5772c3; // bg-blue-400
            border-radius: 50%;
            margin-right: 12px;
            flex-shrink: 0;
            transition: background-color 0.3s;
          }

          .item-title {
            color: #4b5563; // text-gray-600
            font-size: 14px;

            @media (min-width: 640px) {
              font-size: 16px;
            }

            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            transition: color 0.3s;
            margin: 0;
          }
        }

        .item-date {
          color: #9ca3af; // text-gray-400
          font-size: 14px;
          margin-left: 16px;
          font-family: monospace;
          flex-shrink: 0;
        }
      }
    }
  }
}
</style>
